module.exports = __webpack_public_path__ + "img/stack-of-silver.d73f55ed.jpeg";